/**
 * Simple throttle helper: ensures fn() runs at most once every wait ms
 */
function throttle(fn, wait) {
  let last = 0, timeout = null;
  return function(...args) {
    const now = Date.now();
    const remaining = wait - (now - last);
    clearTimeout(timeout);
    if (remaining <= 0) {
      last = now;
      fn.apply(this, args);
    } else {
      timeout = setTimeout(() => {
        last = Date.now();
        fn.apply(this, args);
      }, remaining);
    }
  };
}

if (!customElements.get('shop-the-look')) {
  class ShopTheLook extends HTMLElement {
    constructor() {
      super();
      this.dots = [];
      this.onResizeHandlers = [];
    }

    connectedCallback() {
      this.dots = Array.from(this.querySelectorAll('.thb-hotspot'));
      this.setEventListeners();
    }

    setEventListeners() {
      // Clean up any previous handlers
      this.onResizeHandlers.forEach(h => window.removeEventListener('resize', h));
      this.onResizeHandlers = [];

      // For each dot: do initial layout, then listen on resize (throttled)
      this.dots.forEach((dot) => {
        // Initial position
        this.checkCardPosition(dot);

        // Throttled resize handler
        const handler = throttle(() => this.checkCardPosition(dot), 100);
        window.addEventListener('resize', handler);
        this.onResizeHandlers.push(handler);
      });
    }

    checkCardPosition(dot) {
      const bubble = dot.querySelector('.thb-hotspot-bubble');
      if (!bubble) return;

      // Read layout once
      const dotBounds = bubble.getBoundingClientRect();
      const imageBounds = this.getBoundingClientRect();
      const viewportHeight = document.documentElement.clientHeight;

      // Batch all writes into next paint frame
      window.requestAnimationFrame(() => {
        // Toggle bottom-dot class
        const isBottom = dotBounds.bottom > viewportHeight
           || dotBounds.bottom > imageBounds.bottom;
        dot.classList.toggle('bottom-dot', isBottom);

        // Compute content-offset
        let offset = 0;
        if (dotBounds.right > imageBounds.right) {
          offset = imageBounds.right - dotBounds.right - 15;
        } else if (dotBounds.left < imageBounds.left) {
          offset = imageBounds.left - dotBounds.left + 15;
        }
        dot.style.setProperty('--content-offset', `${offset}px`);
      });
    }

    disconnectedCallback() {
      // Clean up listeners on destroy
      this.onResizeHandlers.forEach(h => window.removeEventListener('resize', h));
    }
  }

  customElements.define('shop-the-look', ShopTheLook);
}